import { Sine, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { BaseCaptionRenderer } from "../GameObjects/BaseCaptionRenderer";

export class LunaCaptionRenderer extends BaseCaptionRenderer {
    private _bg: PIXI.Sprite;
    private _text: PIXI.extras.BitmapText;
    private _textTween: TweenLite | undefined;
    private _bgTween: TweenLite | undefined;

    constructor(pFontName: string, pFontSize: number = 20) {
        super();

        this._bg = HLF.PixiUtils.makeSprite("white-pixel", Constants.SPRITESHEET_UI);
        this._bg.anchor.set(0.5, 0);
        this._bg.height = 60;
        this._bg.tint = 0x000000;
        this._bg.alpha = 0;
        this.addChild(this._bg);

        this._text = new PIXI.extras.BitmapText("", {
            font: {
                name: pFontName,
                size: pFontSize,
            },
        });
        this._text.alpha = 0;
        this._text.visible = false;
        this.addChild(this._text);
    }

    public start(pArgs: any): void {
        this._text.visible = true;
        this._bg.visible = true;
        this.killTween(this._textTween);
        this.killTween(this._bgTween);
        this._textTween = new TweenLite(this._text, 0.25, {
            alpha: 1,
            ease: Sine.easeInOut,
        });
        this._bgTween = new TweenLite(this._bg, 0.15, {
            alpha: 0.6,
            ease: Sine.easeInOut,
        });
        super.start(pArgs);
    }

    public stop(): void {
        this.killTween(this._textTween);
        this.killTween(this._bgTween);
        this._textTween = new TweenLite(this._text, 0.25, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => {
                this._text.visible = false;
            },
        });
        this._bgTween = new TweenLite(this._bg, 0.25, {
            delay: 0.25,
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => {
                this._bg.visible = false;
            },
        });
        super.stop();
    }

    public lineBegin(pLine: SpringRoll.Timedline): void {
        super.lineBegin(pLine);
        this._text.text = pLine.content;
        this.onResize(this._size);
    }

    public lineEnd(): void {
        super.lineEnd();
    }

    public onResize(pSize: PIXI.Point): void {
        super.onResize(pSize);
        this._bg.width = this._size.x;
        this._bg.position.set(this._size.x * 0.5, 0);

        this._text.maxWidth = this._size.x;
        this._text.position.set(
            this._size.x * 0.5 - this._text.textWidth * 0.5,
            15,
        );
    }

    private killTween(pTween: TweenLite | undefined): void {
        if (pTween !== undefined) {
            pTween.kill();
        }
    }
}
